const styles = (theme) => ({
  dialog: {
    width: "75%",
    maxWidth: "75%",
    minHeight: "70%",
    height: "75%",
    maxHeight: "80%",
    backgroundColor: theme.ModalBGColor,
  },
});
export default styles;
